const NewCardGroup = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            fill="currentColor"
            fill-rule="evenodd"
            d="M4.594 3.52h17.71v11.746H20.33v-1.193h.78v-9.36H5.787v.78H4.594V3.522Z"
            clip-rule="evenodd"
        />
        <path
            fill="currentColor"
            d="M6.834 15.731a1.502 1.502 0 1 1 0-1.661 1.5 1.5 0 0 1 2.753.83 1.502 1.502 0 0 1-2.753.831Z"
        />
        <path
            fill="currentColor"
            fill-rule="evenodd"
            d="M1.714 6.587H19.12v6.981h-1.244v-1.414H2.957v5.391h11.045v1.141H1.714V6.587ZM19.12 17.458v.087h2.661v1.141h-2.614v2.768h-1.141v-2.768H15.23v-1.141h2.646v-.087h.015v-2.661h1.229v2.661ZM2.957 7.728v1.92h14.92v-1.92H2.957Z"
            clip-rule="evenodd"
        />
        <path
            fill="currentColor"
            d="M6.86 15.73a1.54 1.54 0 1 1 0-1.703 1.538 1.538 0 0 1 2.821.85 1.54 1.54 0 0 1-2.822.852Z"
        />
    </svg>
);

export default NewCardGroup;
